import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumKeyValue'
})
export class EnumKeyValuePipe implements PipeTransform {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any, skipZero: boolean): { key: string, value: number }[] {
    if (value === undefined || value === null) {
      return [];
    }

    const values = Object.values(value);
    const keys = values.filter(v => isNaN(Number(v)));
    const vals = values.filter(v => !isNaN(Number(v)));

    return keys.map((key, index) => ({
      key: key as string,
      value: Number(vals[index])
    })).filter((val) => !skipZero || val.value > 0);
  }

}
